// REACT DEFAULTS

import { Link } from 'react-router-dom'

// COMPONENTS
import Navbar from '../../components/Navbar'
import Sidebar from '../../components/Sidebar'
import AccountSummary from '../../components/AccountSummary'
import AccountList from '../../components/AccountList'
import AccountDetails from '../../components/AccountDetails'
import Branch from '../../assets/images/icon_branch.png'
import Plus from '../../assets/images/icon_plus.png'

// STYLES & ASSETS
import styles from './Home.module.scss'

const Home = () => {
	return (
		<section className={styles.homeContainer}>
			<Navbar />

			<main className={styles.Dashboard}>
				<Sidebar />

				<div className={styles.DashboardGrid}>
					<div className={styles.AccountCreate}>
						{window.innerWidth > 768 && (
							<h3 className={styles.AccountCreateTitle}>
								Virtual Account Dashboard
							</h3>
						)}

						<div className={styles.AccountCreateBtns}>
							<Link className={styles.AccountCreateBtnBranch} to={'#'}>
								<img src={Branch} alt="branch" />
								<span className={styles.AccountCreateBtnText}>
									Create New Branch
								</span>
							</Link>

							<Link className={styles.AccountCreateBtnVirtual} to={'#'}>
								<img src={Plus} alt="plus" />
								<span className={styles.AccountCreateBtnText}>
									Create Virtual Account
								</span>
							</Link>
						</div>
					</div>

					<aside className={styles.AccountDetailsContainer}>
						<div className={styles.AccountDetails}>
							<AccountSummary />
							<AccountList />
						</div>
						<AccountDetails />
						{/* {window.innerWidth > 768 && <AccountDetails />} */}
					</aside>
				</div>
			</main>
		</section>
	)
}

export default Home
